
    export default {
        props:['tabsData','range','yearSelected'],
        data(){
            return {
              BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
            }
        },
        methods: {
          getImageUrl(key){
            const imgKey = String(key);
            const imageMapping = {
              "1": `${this.BASE_URL_STATIC}/storages/2025-08-14/b226a2ae594b4b7f968628dc925ec113.svg`,
              "2": `${this.BASE_URL_STATIC}/storages/2025-08-14/0e7cc374de034e6383ffbc77cdad7d4a.svg`,
              "3": `${this.BASE_URL_STATIC}/storages/2025-08-14/d134b00236fe4c37a949a3158fbb4748.svg`,
              "4": `${this.BASE_URL_STATIC}/storages/2025-08-14/90b0639f51de42e58340d220a0f1eaa1.svg`,
              "5": `${this.BASE_URL_STATIC}/storages/2025-08-14/69f6d5ac1f064f45ae86defe856244a8.svg`,
            };
            return imageMapping[imgKey] || `${this.BASE_URL_STATIC}/storages/2025-08-14/c7f835539ba24b13a5b0db62dc0c12ce.svg`;
          }
        }
    }
